import { render } from "./Advice5.vue?vue&type=template&id=7bbb74ec&scoped=true"
import script from "./Advice5.vue?vue&type=script&lang=js"
export * from "./Advice5.vue?vue&type=script&lang=js"

import "./Advice5.vue?vue&type=style&index=0&id=7bbb74ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbb74ec"]])

export default __exports__